module.exports = __webpack_public_path__ + "img/methinee.d37fc921.jpg";